import { render, staticRenderFns } from "./LinkText.vue?vue&type=template&id=41e5d6d0&scoped=true"
import script from "./LinkText.vue?vue&type=script&lang=ts"
export * from "./LinkText.vue?vue&type=script&lang=ts"
import style0 from "./LinkText.vue?vue&type=style&index=0&id=41e5d6d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e5d6d0",
  null
  
)

export default component.exports